import { API_URL } from "@/config";
import { axios } from "@/lib/axios";
import { Quiz } from "@/types";

export type ClassQuizzes = {
    [key: number]: {
        id: number;
        quiz: Quiz;
    };
    added_by: number;
    origin: null | number;
}[];

export const getQuizzes = (classId: number): Promise<ClassQuizzes> => {
    return axios.get(`${API_URL}/api/admin/class/${classId}/quiz`);
}
